import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ShimmerPostList } from 'react-shimmer-effects';
import SearchForm from '../../default/search/searchForm';
import RenamePopup from '../../category/view/popup/renameCategory';
import { GetAllConnectionCategory } from '../../../store/actions/new/connectionAction';
import NoContentFound from '../../default/not-found/notFound';
import ItemsSelectorPopup from '../../default/popup/itemsSelectorPopup';
import { handleAddItem, handleAddToCategory, handleCategoryDelete, renameCategoryAction } from '../../../store/actions/new/categoryActions';
import AddNewCategoryPopup from '../../category/view/popup/addNewCategory';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { CONNECTION_CATEGORY_DELETE, CONNECTION_CATEGORY_UPDATE } from '../../../store/constants/connectionConstants';
import ShimmerImage from '../../default/popup/shimmerImage/shimmerImage';
import { InitialAvatar } from '../../default/utils/defaultAvatar';


const ConnectionCategoryList = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };

    //Modal
    const [openModal, setOpen] = useState(false);
    const [openConnectionModal, connectionSet] = useState(false);
    const [openRenameModal, renameSet] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const [loading, setLoading] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const prevSearchTermRef = useRef();
    const [categoryType, setCategoryType] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [catItem, setCatItem] = useState('');
    const [catTitle, setCatTitle] = useState('');

    // Add new connection category
    const handleAddNewModal = () => {
        setOpen(true);
    };
    const AddConnectionCategoryRes = (response) => {
        if (response.status >= 200) {
            let postData = {
                page: 1,
                keyword: ''
            }
            dispatch(GetAllConnectionCategory(postData));
        }
    }

    // Add item to connection category
    const handleAddConnectionModal = (catId, catType) => {
        setCategoryId(catId);
        setCategoryType(catType)
        connectionSet(true);
    };

    const handleItemSelect = async (item) => {
        setCatItem(item);
        connectionSet(false);
        let response = await dispatch(handleAddItem(categoryId, item, categoryType));

        if (response) {
            dispatch(handleAddToCategory(categoryId, item, categoryType));
        }
    };
    // Rename category item
    const handleRenameModal = (id, title) => {
        setCategoryId(id)
        setCatTitle(title)
        renameSet(true);
    };
    const handleUpdateCategory = async (newCategoryName) => {
        setCatTitle(newCategoryName);

        try {
            const response = await dispatch(renameCategoryAction(categoryId, newCategoryName));
            if (response.status >= 200) {
                dispatch({
                    type: CONNECTION_CATEGORY_UPDATE,
                    payload: {
                        catId: categoryId,
                        title: newCategoryName,
                        data: response.data
                    }
                });
                return true;
            }
        } catch (error) {
            console.error('Failed to update category:', error);
        }
    }

    //remove category
    const MySwal = withReactContent(Swal)
    const handleDeleteCategory = (catId, type) => {
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden";
            },
            willClose: () => {
                document.body.style.overflow = "";
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                let response = await dispatch(handleCategoryDelete(catId, type));
                if (response.status >= 200) {
                    dispatch({
                        type: CONNECTION_CATEGORY_DELETE,
                        payload: {
                            catId: catId
                        }
                    })
                }
            }
        });

    }



    //out side click for dropdown
    const handleOutsideClick = (event) => {
        if (event.target.closest('.list-edit-dropdown') === null && !openConnectionModal && !openRenameModal) {
            setOpenDropdown(null);
        }
    };


    // Store data
    const allData = useSelector((state) => state.connectionAllData);
    const { category, error, isLoading } = allData;
    const { data, pagination } = category;
    const dispatch = useDispatch();

    const searchCards = async () => {
        if (!hasLoaded) return;
        setLoading(true);
        let postData = {
            page: 1,
            keyword: searchTerm
        }
        await dispatch(GetAllConnectionCategory(postData));
        setLoading(false);
    }
    const loadMore = () => {
        const nextPage = pagination.page + 1;
        if (nextPage <= pagination.page_last) {
            setPageCount(nextPage);
            let postData = {
                page: nextPage,
                keyword: searchTerm
            }
            dispatch(GetAllConnectionCategory(postData));
        }
    };
    React.useEffect(() => {
        if (!hasLoaded) {
            // Check if store already has data
            if (!category || !category.data || category.data.length === 0) {
                let postData = {
                    page: 1,
                    keyword: ''
                }
                dispatch(GetAllConnectionCategory(postData));
            }
            setHasLoaded(true);
        }
        if (prevSearchTermRef.current !== searchTerm) {
            searchCards();
        }
        prevSearchTermRef.current = searchTerm;

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [openConnectionModal, openRenameModal, searchTerm]);

    return (
        <div className="card-container card-list-area">
            <div className="connection-header">
                <h3>Connection category</h3>
                <div className="filter-wrapper">
                    <SearchForm
                        placeholder='Search Category...'
                        loading={loading}
                        onChange={async (val) => {
                            setSearchTerm(val);
                        }}

                    />
                    <div className="list-filter">
                        <i className="ri-equalizer-line"></i>
                        <span>Filter</span>
                    </div>
                    <div className="list-filter add-new-btn" onClick={handleAddNewModal}>
                        <i className="ri-add-line"></i>
                        <span>Add New</span>
                    </div>
                </div>
            </div>
            {Array.isArray(data) && data.length > 0 && (
                <div className="connection-cat-list">
                    {data && data.map((item, index) => (
                        <div className="single-category-card" key={index}>
                            <div className="cat-info">
                                <h3>
                                    <Link to={`/connection/category/${item.id}`}>{item.title}</Link>
                                </h3>
                                <div className="list-edit-dropdown cat-dropdown">
                                    <i
                                        className="ri-more-2-fill"
                                        onClick={() => toggleDropdown(index)}
                                    ></i>
                                    {openDropdown === index && (
                                        <ul>
                                            <li><Link to={`/connection/category/${item.id}`}>View Category</Link></li>
                                            <li>
                                                <Link
                                                    onClick={() => {
                                                        handleAddConnectionModal(item.id, item.type);
                                                        setOpenDropdown(null);
                                                    }}
                                                >
                                                    Add Connection
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    onClick={() => {
                                                        handleRenameModal(item.id, item.title);
                                                        setOpenDropdown(null);
                                                    }}
                                                >
                                                    Rename
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    onClick={() => {
                                                        handleDeleteCategory(item.id, item.type);
                                                        setOpenDropdown(null);
                                                    }}
                                                >
                                                    Delete
                                                </Link>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                            {item.itemCount > 0 && (
                                <Link to={`/connection/category/${item.id}`} className="category-user-list">
                                    <ul>
                                        {item.items.slice(0, 5).map((catItem, catIndex) => (
                                            <li key={catIndex}>
                                                {catItem.photo ? (
                                                    <ShimmerImage
                                                        src={catItem.photo}
                                                        alt={catItem.title}
                                                        width={80}
                                                    />
                                                ) : (
                                                    <InitialAvatar
                                                        title={`${catItem.title}`}
                                                        borderWidth={2}
                                                        size={80}
                                                    />
                                                )}
                                            </li>
                                        ))}
                                        {item.itemCount > 5 && (
                                            <li className="more-items">
                                                +{item.itemCount - 5} more
                                            </li>
                                        )}
                                    </ul>
                                </Link>
                            )}

                            {!isLoading && item.itemCount === 0 &&
                                <div className="no-content-wrapper">
                                    <NoContentFound title="No item found!" />
                                    <Link onClick={() => handleAddConnectionModal(item.id, item.type)}>Add item</Link>
                                </div>
                            }
                        </div>
                    ))}
                </div>
            )}

            {!isLoading && pagination.data_total === 0 &&
                <NoContentFound title="No category found!" />
            }
            {isLoading &&
                <>
                    <ShimmerPostList title cta row={2} col={3} />
                </>
            }
            {!isLoading && data && pagination.page_last > pagination.page && (
                <div className="load-more-container">
                    <button
                        className="load-more-btn"
                        onClick={loadMore}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Loading...' : 'Load More'}
                    </button>
                </div>
            )}

            <ItemsSelectorPopup openModal={openConnectionModal} setOpen={connectionSet} onItemSelect={handleItemSelect} type="card_connects" title="Add category item" />
            <RenamePopup openModal={openRenameModal} setOpen={renameSet} title={catTitle} onCategoryUpdate={handleUpdateCategory} />
            <AddNewCategoryPopup openModal={openModal} setOpen={setOpen} type="card_connects" onSubmitResponse={AddConnectionCategoryRes} />

        </div>
    );
}

export default ConnectionCategoryList;
